import { AulaEditor } from '@ublend-npm/aula-editor';
import withAnalytics from './withAnalytics';
import withErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import withFileScanFromRedux from './withFileScanFromRedux';

const AulaEditorWithAnalytics = withErrorBoundary(
  withAnalytics(withFileScanFromRedux(AulaEditor)),
  {
    ignore: true,
  }
);

export default AulaEditorWithAnalytics;
